import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {triggerEdapEvent} from '../../utils/triggerEdap';

function MobileApp({logo, ctaLink, appDownloadText, isOpen}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);
    const [showMobileApp, setShowMobileApp] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShowMobileApp(true);
        }
    }, [isOpen]);

    function handleClickMobileApp() {
        triggerEdapEvent(context, 'header.appDownload');
    }

    return ( 
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        showMobileApp && 
        <div className="site-header-tray__menu-item-link" id="trayMobileAppComponent">
            <img className="site-header-tray__menu-item-link--image" 
                src={logo.image}
                alt={logo.altText}
                text={logo.text}
            />
            <a
                className="site-header-tray__menu-item-link--mobileApp-text"
                href={ctaLink}
                onClick={handleClickMobileApp}
            >{appDownloadText}</a>
        </div>
    );
}

MobileApp.propTypes = {
    logo: PropTypes.shape({}).isRequired,
    appDownloadText: PropTypes.string.isRequired,
    ctaLink: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired
};

export {MobileApp};